import {Action, createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';
import * as fromActions from './wizard-actions';
import {AppStateNameEnum} from '@core/enums/app-state-name.enum';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';

export const REDUCER_NAME = AppStateNameEnum.feature_wizard;

export interface State {
    wizardContent: string;
    loading: boolean;
    consentCaseDetails: ConsentUseCaseBasicModel;
}

const initialState: State = {
    wizardContent: '',
    loading: false,
    consentCaseDetails: null
};

const stateSelector = createFeatureSelector<State>(REDUCER_NAME);

export const wizardContentSelector = createSelector(stateSelector, (state: State) => state.wizardContent);
export const loadingSelector = createSelector(stateSelector, (state: State) => state.loading);

const innerReducer = createReducer(
    initialState,
    on(fromActions.GetWizardContent, ((state: State): State => {
        return ({
            ...state,
            loading: true
        });
    })),
    on(fromActions.GetWizardContentSuccess, ((state: State, {wizardContent}): State => ({
        ...state,
        wizardContent,
        loading: false
    }))),
    on(fromActions.SetWizardContent, ((state: State, {wizardContent}): State => ({
        ...state,
        wizardContent,
        loading: false
    }))),
);

export function wizardReducer(state: State | undefined, action: Action): State {
    return innerReducer(state, action);
}


